import React from 'react'
import './sidebar.css'
import { useDispatch, useSelector } from 'react-redux'
import { directSerachTrue, fetchSearch } from '../../redux/Slices/slice'


const Sidebar = ({setDirectSearch, setBars}) => {
  const mediaQuery = window.matchMedia("(min-width: 280px) and (max-width: 800px)");

  const clear = (e) => {
    if(e.matches) {
      setBars(false)
    }
  }



  const dispatch = useDispatch()
  const {userInput, isEmpty} = useSelector(state => state.Store)

  return (
    <div className='barSection'>
      <div className="tabs">
      <h1>{isEmpty===true?`Nothing to show`:'Recents'}</h1>
      <ul className='historyContainer'>
        {userInput.map((input, i) => {return <li key={i} className='searchHistory'
        onClick={()=>{
          clear(mediaQuery)
          let index = userInput.indexOf(input)
          dispatch(fetchSearch(index))
          dispatch(directSerachTrue())
          setDirectSearch(true)
        }}
        >{input}</li>})}
      </ul>
      </div>
      

    </div>
  )
}

export default Sidebar
